import { FastlyImage } from '@components/common/image'
import { Trans } from '@lingui/macro'

type codingCertificateProps = {
  title?: string | JSX.Element
  description?: string | JSX.Element
  image?: {
    src: string
    alt: string
  }
}

const CodingCertificate = ({
  title,
  description,
  image,
}: codingCertificateProps) => {
  return (
    <div className="container mx-auto flex flex-col gap-10 py-12 lg:py-16 text-grey px-5 relative">
      <FastlyImage
        src="/images/home/round-arrow.png"
        alt="Round arrow"
        webpSrc="/images/home/round-arrow.webp"
        width={100}
        height={100}
        className="hidden xl:block absolute left-0"
      />
      <FastlyImage
        src="/images/home/certificate.png"
        alt="Round arrow"
        webpSrc="/images/home/certificate.webp"
        width={100}
        height={100}
        className="hidden xl:block absolute right-0"
      />
      <h2 className="text-2xl lg:text-4xl font-600 lg:mb-3 text-center max-w-4xl mx-auto">
        {title ? (
          title
        ) : (
          <Trans id="home.coding-certificate.title">
            Earn{' '}
            <span className="yellow-underline">AI & coding certifications</span>{' '}
            that make you stand out
          </Trans>
        )}
      </h2>
      <div className="flex flex-col items-center lg:flex-row gap-y-10 lg:gap-y-0 lg:gap-x-10 justify-between">
        <FastlyImage
          src="/images/home/student-certificate.png"
          alt="Coding Certificate"
          width={438}
          height={375}
          {...image}
        />

        <p className="text-lg lg:text-xl w-full lg:w-3/5 text-center lg:text-left">
          {description ? (
            description
          ) : (
            <Trans id="home.coding-certificate.description">
              Every child in our AI & coding classes for kids & teens earns
              STEM.org-accredited certificates that recognise their progress and
              celebrate their achievements. Learners in Grades 1-12 can unlock
              special badges, earn leaderboard rankings, and work towards
              certifications such as Young Scratch Developer, Young Python
              Programmer, Young Web Developer, Young AI Programmer, Advanced AI
              Programmer, Java Developer, AP Computer Science A Champion, and AI
              & Coding Champion. Students who continue into advanced courses can
              also earn AI & Coding Prodigy and AI & Coding Grandmaster
              certifications. Each certificate is easy to download, share on
              social media, and add to your child&apos;s learning portfolio.
            </Trans>
          )}
        </p>
      </div>
    </div>
  )
}

export default CodingCertificate
